var _rect, _rect2, _line, _rect3, _rect4, _circle, _rect5, _line2, _circle2, _rect6, _line3, _circle3, _rect7, _line4, _circle4, _rect8, _line5, _circle5, _rect9, _line6, _rect0, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopMyNewsPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 795,
  viewBox: "0 0 300 795",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1.36963,
  width: 299,
  height: 793,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.8696,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 52.3696,
  x2: 20,
  y2: 52.3696,
  stroke: "black"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 71.8696,
  width: 160,
  height: 29,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 108.87,
  width: 261,
  height: 16,
  fill: "#E5E5E5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 154.87,
  r: 10,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 144.87,
  width: 228,
  height: 70,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 235.37,
  x2: 20,
  y2: 235.37,
  stroke: "#E5E5E5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 264.87,
  r: 10,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 254.87,
  width: 228,
  height: 70,
  fill: "#E5E5E5"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 345.37,
  x2: 20,
  y2: 345.37,
  stroke: "#E5E5E5"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 374.87,
  r: 10,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 364.87,
  width: 228,
  height: 70,
  fill: "#E5E5E5"
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 455.37,
  x2: 20,
  y2: 455.37,
  stroke: "#E5E5E5"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 484.87,
  r: 10,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 474.87,
  width: 228,
  height: 70,
  fill: "#E5E5E5"
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 565.37,
  x2: 20,
  y2: 565.37,
  stroke: "#E5E5E5"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 594.87,
  r: 10,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 584.87,
  width: 228,
  height: 70,
  fill: "#E5E5E5"
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 675.37,
  x2: 20,
  y2: 675.37,
  stroke: "#E5E5E5"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 694.87,
  width: 160,
  height: 30,
  fill: "#E5E5E5"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 744.87,
  width: 260,
  height: 30,
  fill: "#E5E5E5"
})));
export default SvgDesktopMyNewsPlaceholder;